import { NotificationIconName } from '../../features/notifications/notificationsSlice'
import CsvFileSvg from '../../assets/inlineSvg/csvFile.svg'
import PdfFileSvg from '../../assets/inlineSvg/icon-pdf.svg'
import JsonFileSvg from '../../assets/inlineSvg/icon-json.svg'
import React, { ReactNode } from 'react'
import { FileZip } from 'phosphor-react'

import './NotificationIcon.less'

export function iconNameToIconFile(iconName?: NotificationIconName) {
  switch (iconName) {
    case 'csv':
      return <CsvFileSvg />
    case 'pdf':
      return <PdfFileSvg />
    case 'json':
      return <JsonFileSvg style={{ minWidth: '24px', transform: `scale(calc(16 / 24))` }} />
    case 'zip':
      return <FileZip size={32} />
    default:
      return null
  }
}

type NotificationIconProps = {
  children: ReactNode
}

export function NotificationIcon({ children }: NotificationIconProps) {
  return <div className="NotificationIcon">{children}</div>
}
